"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemperatureUnitSchema = void 0;
const zod_1 = require("zod");
exports.TemperatureUnitSchema = zod_1.z.enum(['celsius', 'F', 'K']);
exports.default = exports.TemperatureUnitSchema;
//# sourceMappingURL=TemperatureUnitSchema.js.map